document.querySelectorAll('.js-popup').forEach(($target) => {
  $target.addEventListener('click', (event) => {
    // Prevent default event
    event.preventDefault();

    // Get link target
    const link = event.currentTarget.href;
    const shareTitle = 'Inhalt teilen';
    const shareParams = 'width=500,height=300,resizable=yes';

    // Try to open popup
    try {
      window.open(link, shareTitle, shareParams).focus();
    } catch (e) {
      // Nothing todo
    }
  });
});



// WEBPACK FOOTER //
// ./src/javascripts/shared/popup.js